import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Definir la variable `db`
let db;

const request = indexedDB.open("miBaseDeDatos", 1);

request.onerror = (event) => {
  console.error("Error al abrir la base de datos:", event.target.errorCode);
};

request.onsuccess = (event) => {
  db = event.target.result;
  console.log("Base de datos abierta con éxito");
};

request.onupgradeneeded = (event) => {
  db = event.target.result;
  if (!db.objectStoreNames.contains("notas")) {
    const objectStore = db.createObjectStore("notas", { keyPath: "id", autoIncrement: true });
    objectStore.createIndex("materia", "materia", { unique: false });
    objectStore.createIndex("nota", "nota", { unique: false });
    objectStore.createIndex("profesor", "profesor", { unique: false });
    console.log("Object store 'notas' creado con éxito");
  }
};

// Función para guardar una nota
function guardarNota(notaObj) {
  if (!db) {
    console.error("La base de datos no está lista aún.");
    return;
  }
  const transaction = db.transaction(["notas"], "readwrite");
  const objectStore = transaction.objectStore("notas");

  const request = objectStore.add(notaObj);

  request.onsuccess = () => {
    console.log("Nota guardada con éxito:", notaObj);
  };

  request.onerror = (event) => {
    console.error("Error al guardar la nota:", event.target.errorCode);
  };
}

// Función para obtener todas las notas
function obtenerNotas() {
  if (!db) {
    console.error("La base de datos no está lista aún.");
    return;
  }
  const transaction = db.transaction(["notas"], "readonly");
  const objectStore = transaction.objectStore("notas");

  const request = objectStore.getAll();

  request.onsuccess = (event) => {
    console.log("Notas obtenidas:", event.target.result);
  };

  request.onerror = (event) => {
    console.error("Error al obtener las notas:", event.target.errorCode);
  };
}

// Ejemplo de uso
obtenerNotas();

document.getElementById('saveButton').addEventListener('click', () => {
  const materia = document.getElementById('materiaInput').value;
  const nota = document.getElementById('notaInput').value;
  const profesor = document.getElementById('profesorInput').value;

  if (materia && nota && profesor) {
    const notaObj = {
      materia: materia,
      nota: nota,
      profesor: profesor,
      fecha: new Date().toLocaleDateString()
    };
    console.log("Guardando nota:", notaObj);
    guardarNota(notaObj);
  } else {
    console.error("Todos los campos son obligatorios para guardar una nota.");
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

